import { BaseModel } from './baseModel';

export type UserModel = { firstName: string; lastName: string; email: string; password: string } & BaseModel;

export enum RoleEnum {
  Basic = 0,
  Admin = 1,
  SuperAdmin = 2
}
